import { Card, SimpleSelect } from 'corso-admin-ui';
import { StoreProductStatus, storeProductStatusName } from 'corso-types';
import { Controller } from 'react-hook-form';
import { useProductFormContext } from '~/features/products/ProductForm';
import { useProduct } from '~/features/products/ProductProvider';

const statusOptions = Object.values(StoreProductStatus).map((value) => ({
  value,
  label: storeProductStatusName[value],
}));

export function ProductStatus() {
  const product = useProduct();
  const { control } = useProductFormContext();

  return (
    <Card>
      <Controller
        control={control}
        name="status"
        render={({ field: { value, onChange }, fieldState }) => (
          <SimpleSelect
            label="Status"
            options={statusOptions}
            value={value}
            onChange={onChange}
            disabled={!product.isOffPlatform}
            error={fieldState.error?.message}
          />
        )}
      />
    </Card>
  );
}
